import React from "react";
import type { Devise, Frequence, PlanType } from "../../../lib/api/plansAbonnement";

export type PlanSummaryStickyProps = {
  planType: PlanType;
  zoneLabel: string;
  frequence: Frequence;
  passagesParMois: number;
  dotations: string[];
  services: string[];
  prixBase: number;
  supplements: number;
  totalMensuel: number;
  devise: Devise;
  blockers: string[];
};

function slaForType(type: PlanType): string {
  if (type === "PROFESSIONNEL") return "Collecte renforcée";
  if (type === "CHANTIER") return "Collecte intensive";
  return "Collecte standard";
}

export function PlanSummarySticky(props: PlanSummaryStickyProps): React.JSX.Element {
  return (
    <aside className="sticky top-0 self-start rounded-2xl border border-slate-800 bg-slate-900/70 p-4 text-sm text-slate-200">
      <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">Synthèse commerciale</p>
      <div className="mt-2 flex flex-wrap gap-2">
        <span className="rounded-full bg-emerald-500/20 px-2 py-0.5 text-xs text-emerald-200">{props.planType}</span>
      </div>
      <p className="mt-2 text-slate-300">Zone: {props.zoneLabel}</p>

      <div className="mt-3 border-t border-slate-800 pt-3">
        <span className="inline-flex rounded-full bg-emerald-500/20 px-2 py-0.5 text-xs text-emerald-200">
          Collecte incluse
        </span>
        <p className="mt-2">Fréquence: {props.frequence}</p>
        <p>Passages/mois: {props.passagesParMois}</p>
        <p>SLA: {slaForType(props.planType)}</p>
      </div>

      <div className="mt-3 border-t border-slate-800 pt-3">
        <p className="text-xs uppercase tracking-wide text-slate-400">Dotations</p>
        <p>{props.dotations.length ? props.dotations.join(", ") : "Pas de matériel inclus"}</p>
      </div>

      <div className="mt-3 border-t border-slate-800 pt-3">
        <p className="text-xs uppercase tracking-wide text-slate-400">Services optionnels</p>
        <p>{props.services.length ? props.services.join(", ") : "Aucun service optionnel"}</p>
      </div>

      <div className="mt-3 border-t border-slate-800 pt-3">
        <p>Base: {props.prixBase.toFixed(2)} {props.devise}</p>
        <p>Suppléments: {props.supplements.toFixed(2)} {props.devise}</p>
        <p className="text-xl font-bold text-emerald-400">
          Total mensuel: {props.totalMensuel.toFixed(2)} {props.devise}
        </p>
      </div>

      <div className="mt-3 border-t border-slate-800 pt-3">
        {props.blockers.length === 0 ? (
          <p className="text-emerald-300">✅ Plan prêt à créer</p>
        ) : (
          props.blockers.map((msg) => (
            <p key={msg} className="text-amber-300">⚠ {msg}</p>
          ))
        )}
      </div>
    </aside>
  );
}

